import React, { useState } from 'react';
import { Textarea } from './ui/textarea';
import { Button } from './ui/button';
import { Undo2, Loader2 } from 'lucide-react';
import { MicButton } from './MicButton';
import { api } from '../lib/api';

export const DictationField = ({ value, onChange, rows, placeholder, testId, context }) => {
  const [undo, setUndo] = useState(null);
  const [cleaning, setCleaning] = useState(false);
  const dictate = async (raw) => {
    const before = value;
    const join = (t) => (before ? `${before.trim()}\n${t}` : t);
    onChange(join(raw));
    setCleaning(true);
    try { const { data } = await api.post('/dictation/clean', { text: raw, context }); onChange(join(data.cleaned)); setUndo({ before, raw: join(raw) }); }
    catch { setUndo({ before, raw: join(raw) }); }
    finally { setCleaning(false); }
  };
  return (
    <div>
      <Textarea rows={rows} value={value} onChange={(e) => { onChange(e.target.value); setUndo(null); }} placeholder={placeholder} data-testid={testId} />
      <div className="mt-1.5 flex items-center gap-2 flex-wrap">
        <MicButton label="Dictate" testId={`${testId}-mic`} onText={dictate} />
        {cleaning && <span className="text-xs text-muted-foreground flex items-center gap-1" data-testid={`${testId}-cleaning`}><Loader2 className="w-3 h-3 animate-spin" /> Tidying into sentences…</span>}
        {undo && !cleaning && <Button type="button" size="sm" variant="ghost" onClick={() => { onChange(undo.raw); setUndo({ ...undo, restored: true }); }} disabled={undo.restored} data-testid={`${testId}-undo`}><Undo2 className="w-3.5 h-3.5 mr-1" /> {undo.restored ? 'Raw transcript restored' : 'Undo tidy-up (keep my exact words)'}</Button>}
      </div>
    </div>
  );
};
